var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsIn, IsInt, IsObject, IsOptional, IsString, MaxLength, ValidateNested } from 'class-validator';
import { Fact } from './facts/fact';
import { Links } from './links/links';
import { ManfrediteAvailabilityStatusValues } from './manfredite-availability-status';
import { ManfrediteContractTypeValues } from './manfredite-contract-type';
import { ProfilePreferences } from './profile-preferences/profile-preferences';
import { ManfrediteTechnologyRequest } from './techs';
import { WorkplacePreferencesUpdate } from './workplace-preferences/workplace-preferences';
/**
 * Affected endpoints
 * PUT /manfredite
 */
export class ManfrediteUpdateRequest {
    static _OPENAPI_METADATA_FACTORY() {
        return { firstName: { required: false, type: () => String, maxLength: 255 }, lastName: { required: false, type: () => String, maxLength: 255 }, whereDoYouLiveId: { required: false, type: () => String }, telephone: { required: false, type: () => String, maxLength: 255 }, headline: { required: false, type: () => String }, introduction: { required: false, type: () => String }, softSkills: { required: true, type: () => [Number] }, goodPractices: { required: false, type: () => String }, facts: { required: true, type: () => [require("./facts/fact").Fact] }, links: { required: true, type: () => require("./links/links").Links }, yearsOfExperienceId: { required: false, type: () => Number }, desiredRoles: { required: true, type: () => [Number] }, desiredSalaryId: { required: false, type: () => Number }, desiredSalaryDescription: { required: false, type: () => String }, currentSalary: { required: false, type: () => Number }, desiredJobDescription: { required: false, type: () => String }, techs: { required: false, type: () => [require("./techs/manfredite-technology-update.request").ManfrediteTechnologyRequest] }, likedTechs: { required: true, type: () => [Number] }, dislikedTechs: { required: true, type: () => [Number] }, workplacePreferences: { required: true, type: () => require("./workplace-preferences/workplace-preferences").WorkplacePreferencesUpdate }, profilePreferences: { required: true, type: () => require("./profile-preferences/profile-preferences").ProfilePreferences }, cvFileId: { required: false, type: () => Number }, avatarId: { required: false, type: () => Number }, availabilityStatus: { required: true, type: () => Object, enum: ManfrediteAvailabilityStatusValues }, contractTypes: { required: true, type: () => [Object], enum: ManfrediteContractTypeValues }, preferredLanguage: { required: true, type: () => Object, enum: ['EN', 'ES'] }, isNewsletterActive: { required: true, type: () => Boolean }, isInterestedOnWorkAtManfred: { required: true, type: () => Boolean }, tags: { required: true, type: () => [Number] } };
    }
}
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "firstName", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "whereDoYouLiveId", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "telephone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "headline", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "introduction", void 0);
__decorate([
    IsArray(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "softSkills", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "goodPractices", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Fact),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "facts", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => Links),
    __metadata("design:type", Links)
], ManfrediteUpdateRequest.prototype, "links", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteUpdateRequest.prototype, "yearsOfExperienceId", void 0);
__decorate([
    IsArray(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "desiredRoles", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteUpdateRequest.prototype, "desiredSalaryId", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "desiredSalaryDescription", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteUpdateRequest.prototype, "currentSalary", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "desiredJobDescription", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => ManfrediteTechnologyRequest),
    IsOptional(),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "techs", void 0);
__decorate([
    IsArray(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "likedTechs", void 0);
__decorate([
    IsArray(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "dislikedTechs", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => WorkplacePreferencesUpdate),
    __metadata("design:type", WorkplacePreferencesUpdate)
], ManfrediteUpdateRequest.prototype, "workplacePreferences", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => ProfilePreferences),
    __metadata("design:type", ProfilePreferences)
], ManfrediteUpdateRequest.prototype, "profilePreferences", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteUpdateRequest.prototype, "cvFileId", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteUpdateRequest.prototype, "avatarId", void 0);
__decorate([
    IsString(),
    IsIn(ManfrediteAvailabilityStatusValues),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "availabilityStatus", void 0);
__decorate([
    IsArray(),
    IsIn(ManfrediteContractTypeValues, { each: true }),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "contractTypes", void 0);
__decorate([
    IsString(),
    IsIn(['EN', 'ES']),
    __metadata("design:type", String)
], ManfrediteUpdateRequest.prototype, "preferredLanguage", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ManfrediteUpdateRequest.prototype, "isNewsletterActive", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ManfrediteUpdateRequest.prototype, "isInterestedOnWorkAtManfred", void 0);
__decorate([
    IsArray(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ManfrediteUpdateRequest.prototype, "tags", void 0);
//# sourceMappingURL=manfredite-update.request.js.map